import { useEffect } from 'react';

/**
 * Call `onEscape` whenever the user presses Escape while `active` is true.
 * Pass `active=false` to disable the listener (e.g. when the modal is closed).
 */
export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (!active) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onEscape();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [active, onEscape]);
}
